import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import { Tooltip } from '../Tooltip';

const styles = (theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    marginLeft: theme.spacing.unit / 2,
    fontSize: 18,
  },
});

class PatientCustomError extends React.PureComponent {
  render() {
    const { classes, hideTooltip, IconProps, text } = this.props;

    return (
      <span className={classes.root}>
        {text}
        {!hideTooltip && (
          <Tooltip title="Currently, we cannot send appointment offers via voice call when offers are broadcasted out">
            <Icon className={classes.icon} {...IconProps}>
              help
            </Icon>
          </Tooltip>
        )}
      </span>
    );
  }
}

PatientCustomError.propTypes = {
  classes: PropTypes.object.isRequired,
  hideTooltip: PropTypes.bool,
  IconProps: PropTypes.object,
  text: PropTypes.string,
};

PatientCustomError.defaultProps = {
  hideTooltip: false,
  IconProps: {},
  text: 'This patient can’t be selected because of their contact preferences',
};

export default withStyles(styles)(PatientCustomError);
